export const BACKGROUND = {
  PRIMARY: "#9b3789",
};
